import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import KnowledgeBaseContent from "./KnowledgeBaseContent";
import KnowledgeBaseSearch from "./KnowledgeBaseSearch";
import KnowledgeBaseSidebar from "./KnowledgeBaseSidebar";
import "./KnowledgeBase.css";

const KnowledgeBase = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const articleParam = searchParams.get("article") || "procedure-workflow";
  const [activeArticleId, setActiveArticleId] = useState(articleParam);

  const handleSelectArticle = (articleId) => {
    setActiveArticleId(articleId);
    setSearchParams({ article: articleId });
  };

  return (
    <div className="kb-container">
      {/* Unified Hero Header Banner */}
      <div className="kb-hero">
        <div className="kb-hero-title">Knowledge Base</div>
        <div className="kb-hero-subtitle">
          Explore comprehensive guides, workflows, and step-by-step documentation
        </div>
        <KnowledgeBaseSearch onSelectArticle={handleSelectArticle} />
      </div>

      {/* Main Grid Layout */}
      <div className="kb-layout">
        <KnowledgeBaseSidebar
          activeArticleId={activeArticleId}
          onSelectArticle={handleSelectArticle}
        />
        <KnowledgeBaseContent activeArticleId={activeArticleId} />
      </div>
    </div>
  );
};

export default KnowledgeBase;
